(() => {
if (customElements.get('wildgainz-tip')) return;
/* Wild Gainz inline explainer.

   A small ⓘ button that reveals a short answer next to the thing that raised
   the question. Click or keyboard to open, Escape or an outside click to
   close. Only one is open at a time. Deliberately not on hover: it would
   flicker open as the pointer crosses the line.

   Progressive enhancement: without this script the panel is already visible
   (the stylesheet only hides it under .wg-js), so the explanation is never
   lost, it just does not fold away.

   Markup contract:
     <wildgainz-tip class="wg-tip">
       <button class="wg-tip__btn" aria-expanded="false" aria-controls="ID">ⓘ</button>
       <span class="wg-tip__panel" id="ID" role="note">...</span>
     </wildgainz-tip>
*/
class WildgainzTip extends HTMLElement {
  connectedCallback() {
    this.classList.add('wg-js');
    if (this.__wgBound) return;
    this.__wgBound = true;

    this.button = this.querySelector('.wg-tip__btn');
    if (!this.button) return;

    this.button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.toggle(!this.open);
    });

    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.open) {
        this.toggle(false);
        this.button.focus();
      }
    });

    /* The tip sits inside a dialog on some pages, so listen on this element's
       root rather than document to keep working in either place. */
    (this.getRootNode() || document).addEventListener('click', (event) => {
      if (this.open && !this.contains(event.target)) this.toggle(false);
    });
  }

  get open() {
    return this.hasAttribute('data-open');
  }

  toggle(next) {
    if (next) {
      const root = this.getRootNode() || document;
      root.querySelectorAll('wildgainz-tip[data-open]').forEach((other) => {
        if (other !== this) other.toggle(false);
      });
    }
    this.toggleAttribute('data-open', next);
    if (this.button) this.button.setAttribute('aria-expanded', next ? 'true' : 'false');
  }
}

customElements.define('wildgainz-tip', WildgainzTip);
})();
